import React from 'react'
import './SectionCard.scss'

export function SectionCard({ title, subtitle, children, className = '' }) {
  return (
    <section className={`enviar-planilha-section-card ${className}`.trim()}>
      <header className="enviar-planilha-section-card__header">
        <h2 className="enviar-planilha-section-card__title">{title}</h2>
        {subtitle ? (
          <p className="enviar-planilha-section-card__subtitle">{subtitle}</p>
        ) : null}
      </header>
      <div className="enviar-planilha-section-card__body">{children}</div>
    </section>
  )
}
